module.exports = __webpack_public_path__ + "img/ctcc.c42c7d3b.png";